export const tokens = {
    header: {
        gap: 16,
        titleSize: 40,
        subtitleSize: 18,
    },
    section: {
        gap: 16,
        titleSize: 18,
        actionSize: 12,
    },
    list: {
        gap: 10,
    },
};
